import { render, staticRenderFns } from "./DashboardStudent.vue?vue&type=template&id=178a67eb&"
import script from "./DashboardStudent.vue?vue&type=script&lang=ts&"
export * from "./DashboardStudent.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardStudent.vue?vue&type=style&index=0&id=178a67eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports